// extracted by mini-css-extract-plugin
export default {"details":"styles_details__v8ISg","attachments":"styles_attachments__VsrR0","block":"styles_block__a6RY6"};